import { render, staticRenderFns } from "./requester-info.vue?vue&type=template&id=22faa456&"
import script from "./requester-info.vue?vue&type=script&lang=js&"
export * from "./requester-info.vue?vue&type=script&lang=js&"
import style0 from "./requester-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports